import { P2GBox } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import {
  ActionType,
  IntergrationInstructionContent,
  IntergrationInstructionStep,
  StrVal
} from '../../../lib/api/account-linking/types';
import { P2GGrid } from '@parcel2go/core-ui';
import StepInput from './StepInput';
import { P2GImage } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  step: IntergrationInstructionStep;
  stepNumber: number;
  showInstructions: boolean;
  showNumber: boolean;
  saving: boolean;
  values: StrVal;
  onUpdate: (key: string, value: string) => void;
  integrationType: string;
  integrationSlug: string;
  action: ActionType;
  onFileUploadSubmission?: () => void;
}

export function Content(props: IntergrationInstructionContent) {
  const { t } = useTranslation(TranslationNamespaces.ACCOUNT_LINKING);
  switch (props.elementType) {
    case 'Image':
      return <P2GImage style={{ width: '100%' }} src={props.attributes['src']} alt={props.attributes['alt']} />;
    case 'UnOrderedList':
      return (
        <ul>
          {props.childElements.map((c) => (
            <li key={c.content}>
              <P2GBox pt={1} pb={1}>
                <P2GText variant="body2">{t(c.translationKey, { defaultValue: c.content })}</P2GText>
              </P2GBox>
            </li>
          ))}
        </ul>
      );
    default:
      return <P2GText variant="body2">{t(props.translationKey, { defaultValue: props.content })}</P2GText>;
  }
}

export function StepRow(props: { left: ReactNode; right: ReactNode }) {
  return (
    <P2GGrid container wrap="nowrap" spacing={2}>
      {props.left && (
        <P2GGrid item xs={1}>
          {props.left}
        </P2GGrid>
      )}
      <P2GGrid item xs={props.left ? 11 : 12}>
        {props.right}
      </P2GGrid>
    </P2GGrid>
  );
}

export default function Step(props: props) {
  return (
    <StepRow
      left={props.showNumber && <P2GText variant="h2">{props.stepNumber}</P2GText>}
      right={
        <>
          {props.showInstructions && (
            <P2GBox mb={2}>
              {props.step.content?.map((c, i) => (
                <P2GBox key={c.content} mt={i > 0 ? 1 : 0}>
                  <Content {...c} />
                </P2GBox>
              ))}
            </P2GBox>
          )}
          {props.step.inputs?.length > 0 && (
            <P2GGrid container gap={2} direction="column">
              {props.step.inputs.map((i) => (
                <P2GGrid item xs={12} key={i.propertyName}>
                  <StepInput
                    disabled={props.saving}
                    input={i}
                    value={props.values[i.propertyName]}
                    onUpdate={props.onUpdate}
                    integrationType={props.integrationType}
                    integrationSlug={props.integrationSlug}
                    action={props.action}
                    onFileUploadSubmission={props.onFileUploadSubmission}
                  />
                </P2GGrid>
              ))}
            </P2GGrid>
          )}
        </>
      }
    />
  );
}
